import React from "react";

export default function TechnicienDashboard() {
    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold text-blue-800 mb-6">
                🛠️ Dashboard Technicien
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-2xl shadow text-center">
                    <h2 className="text-lg font-semibold mb-2">📺 TVSahel</h2>
                    <p className="text-gray-600">
                        Gestion des vidéos diffusées
                    </p>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow text-center">
                    <h2 className="text-lg font-semibold mb-2">⚙️ Système</h2>
                    <p className="text-gray-600">
                        Maintenance et monitoring
                    </p>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow text-center">
                    <h2 className="text-lg font-semibold mb-2">📊 Statistiques</h2>
                    <p className="text-gray-600">
                        Analyse des activités
                    </p>
                </div>
            </div>
        </div>
    );
}